import { render } from "./commision.vue?vue&type=template&id=26c697aa"
import script from "./commision.vue?vue&type=script&lang=js"
export * from "./commision.vue?vue&type=script&lang=js"

import "./commision.vue?vue&type=style&index=0&id=26c697aa&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__